import { useEffect, useRef, useState } from 'react';

const logos = [
  {
    name: 'Holiday Inn by IHG',
    url: 'https://storage.readdy-site.link/project_files/390fbdda-ccd9-47f3-ab63-db1f61ff7592/886430b5-3596-4fdd-9988-152c1a2e9829_Holiday_Inn_by_IHG_logo.svg.png?v=e99897f566d66cec4edc252b8d035355',
    width: 'w-52',
  },
  {
    name: 'Holiday Inn Express by IHG',
    url: 'https://storage.readdy-site.link/project_files/390fbdda-ccd9-47f3-ab63-db1f61ff7592/9a760e7a-6fe7-491b-86bc-5d343da7e982_Holiday_Inn_Express_by_IHG_logo.svg.png?v=ea73eb73a0aa315d806c2c7e6489bb39',
    width: 'w-64',
  },
  {
    name: 'Staybridge Suites by IHG',
    url: 'https://storage.readdy-site.link/project_files/390fbdda-ccd9-47f3-ab63-db1f61ff7592/463ae483-e728-4b9c-bde0-2d395e0c8b69_Staybridge_Suites_by_IHG_logo.svg?v=7767472ea73613b4f2c820486a5b5a20',
    width: 'w-64',
  },
  {
    name: 'Fairfield by Marriott',
    url: 'https://storage.readdy-site.link/project_files/390fbdda-ccd9-47f3-ab63-db1f61ff7592/cf78aa2a-9d12-45ff-b485-6640e71905c5_Fairfield_by_Marriott_Logo.webp?v=f9b65ec1f0823c6fce66d03f6640e963',
    width: 'w-48',
  },
  {
    name: 'IHG Partner',
    url: 'https://storage.readdy-site.link/project_files/390fbdda-ccd9-47f3-ab63-db1f61ff7592/1f186f8f-a76f-435a-81c5-42e16c160a9e_images.png?v=200150d2dd2cbb2a7effcfd63a74d796',
    width: 'w-40',
  },
];

export default function BrandLogosStrip() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="bg-white border-b border-stone-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10 lg:py-12">
        {/* Label */}
        <p
          className={`text-center text-xs font-medium text-stone-400 uppercase tracking-[0.3em] mb-8 transition-all duration-600 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Trusted by leading IHG brand properties across Florida
        </p>

        {/* Logo row */}
        <div className="flex items-center justify-between gap-4 lg:gap-6">
          {logos.map((logo, i) => (
            <div
              key={logo.name}
              className={`flex items-center justify-center flex-1 transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <img
                src={logo.url}
                alt={logo.name}
                className="w-full h-auto object-contain grayscale hover:grayscale-0 transition-all duration-400 opacity-70 hover:opacity-100"
                style={{ maxHeight: '72px', maxWidth: '200px' }}
              />
            </div>
          ))}
        </div>

        {/* Divider accent */}
        <div className="flex items-center justify-center mt-10 gap-3">
          <div className="h-px w-16 bg-stone-200"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-amber-400"></div>
          <div className="h-px w-16 bg-stone-200"></div>
        </div>
      </div>
    </section>
  );
}
